import React from 'react';

export interface Props {
  message: string,
}

export default function PurchaseSubscriptionSuccess({ message }: Props) {
  return (
    <div>
      <h1 className="heading heading--3">Success!</h1>
      <p dangerouslySetInnerHTML={{ __html: message }} />
    </div>
  );
}